import * as React from "react";

function SvgGl(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 512 336"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M512.001 168H0V9.103A8.829 8.829 0 018.828.275h494.345a8.829 8.829 0 018.828 8.828V168z"
          fill="#F5F5F5"
        />
        <path
          d="M0 168h512v158.897a8.829 8.829 0 01-8.828 8.828H8.828A8.829 8.829 0 010 326.897V168zM176.552 53.241c-63.38 0-114.759 51.38-114.759 114.759H291.31c0-63.379-51.378-114.759-114.758-114.759z"
          fill="#FF4B55"
        />
        <path
          d="M176.552 282.759c63.38 0 114.759-51.38 114.759-114.759H61.793c0 63.38 51.38 114.759 114.759 114.759z"
          fill="#F5F5F5"
        />
      </g>
    </svg>
  );
}

export default SvgGl;
